const CDN = "https://assets.cdn.filesafe.space/Q8tVdBwjIBJYLzAfhCJr/media/";

export const IMAGES = {
  logo: CDN + "6ad590b3cd7225ed37dd8657.png", // transparent round badge logo
  favicon: CDN + "6ad590c23cacdd9117b97e6d.png",
  appleTouch: CDN + "6ad590c2cd7225ed37dd87eb.png",
  coverBanner: CDN + "6ad590c2989628c77a6fe620.jpg", // brand banner, 1600x595
  hero: CDN + "6ad590c23cacdd9117b97e6e.jpg", // gray kitchen, granite counters, mosaic backsplash
  kitchenClean1: CDN + "6ad590c2f9a985d42c07eab4.jpg", // double sink, blue tile counters (720x960)
  kitchenClean2: CDN + "6ad590c2f9a985d42c07eabf.jpg", // white stove, blue tile backsplash
  kitchenClean3: CDN + "6ad590c3cd7225ed37dd87ff.jpg", // dark-cabinet kitchen with granite
  livingRoom1: CDN + "6ad590c33cacdd9117b97e93.jpg", // bay windows, plank floors
  livingRoom2: CDN + "6ad590c3989628c77a6fe638.jpg", // fireplace and French doors
  fireplace1: CDN + "6ad590c3989628c77a6fe650.jpg", // brick fireplace, plank floors
  bathroom1: CDN + "6ad590c43cacdd9117b97eab.jpg", // double vanity, dark cabinets
  bathroom2: CDN + "6ad590c7989628c77a6fe72b.jpg", // tub with gray tile surround
  bathroom3: CDN + "6ad590c7f9a985d42c07ebd2.jpg", // white vanity and toilet, gray tile
  bathroom4: CDN + "6ad590c7989628c77a6fe720.jpg", // vanity, toilet and tub
  bedroom1: CDN + "6ad590c73cacdd9117b97f7b.jpg", // empty bedroom, wood floors, blinds
  bedroom2: CDN + "6ad590c73cacdd9117b97f81.jpg", // bright room, wood floors, large window
  floors1: CDN + "6ad590c73cacdd9117b97f76.jpg", // glossy wood floors, empty room
  floors2: CDN + "6ad590c8f9a985d42c07ebfe.jpg", // fireplace room, plank floors
  moveOut1: CDN + "6ad590c8f9a985d42c07ec10.jpg", // empty move-out-ready room
  hallway1: CDN + "6ad590c83cacdd9117b97fd3.jpg", // tiled hallway
  stairs1: CDN + "6ad590c83cacdd9117b97fde.jpg", // vacuumed carpeted staircase
  builtIns1: CDN + "6ad590c8989628c77a6fe784.jpg", // dusted built-in shelves
} as const;

/**
 * Responsive image URL helper. Resizes/optimizes through the image CDN and
 * returns a WebP at the given width and quality. Pass the raw CDN URL as `url`.
 */
export const img = (url: string, w: number, q = 80) =>
  `https://images.leadconnectorhq.com/image/f_webp/q_${q}/r_${w}/u_${url}`;

// Gallery (19 photos). Each links to the 1200px version in the lightbox.
export const GALLERY: { src: string; alt: string }[] = [
  {
    src: IMAGES.hero,
    alt: "Kitchen with granite counters and mosaic backsplash cleaned by Pretty in Pink Cleaning Service in Wetumpka, AL",
  },
  {
    src: IMAGES.kitchenClean1,
    alt: "Double sink and blue tile kitchen counters detailed by Pretty in Pink Cleaning Service in Wetumpka, AL",
  },
  {
    src: IMAGES.kitchenClean2,
    alt: "White stove and blue tile backsplash after a kitchen clean by Pretty in Pink Cleaning Service in Wetumpka, AL",
  },
  {
    src: IMAGES.kitchenClean3,
    alt: "Dark-cabinet kitchen with granite counters cleaned by Pretty in Pink Cleaning Service near Millbrook, AL",
  },
  {
    src: IMAGES.livingRoom1,
    alt: "Living room with bay windows and plank floors vacuumed by Pretty in Pink Cleaning Service in Wetumpka, AL",
  },
  {
    src: IMAGES.livingRoom2,
    alt: "Living room with fireplace and French doors dusted by Pretty in Pink Cleaning Service near Prattville, AL",
  },
  {
    src: IMAGES.fireplace1,
    alt: "Brick fireplace and plank floors in a living room cleaned by Pretty in Pink Cleaning Service in Wetumpka, AL",
  },
  {
    src: IMAGES.bathroom1,
    alt: "Double vanity with dark cabinets in a bathroom cleaned by Pretty in Pink Cleaning Service in Wetumpka, AL",
  },
  {
    src: IMAGES.bathroom2,
    alt: "Bathtub with gray tile surround scrubbed by Pretty in Pink Cleaning Service near Montgomery, AL",
  },
  {
    src: IMAGES.bathroom3,
    alt: "White vanity and toilet with gray tile in a bathroom deep-cleaned by Pretty in Pink Cleaning Service in Wetumpka, AL",
  },
  {
    src: IMAGES.bathroom4,
    alt: "Vanity, toilet and tub in a bathroom cleaned by Pretty in Pink Cleaning Service near Montgomery, AL",
  },
  {
    src: IMAGES.bedroom1,
    alt: "Empty bedroom with wood floors and blinds dusted by Pretty in Pink Cleaning Service near Tallassee, AL",
  },
  {
    src: IMAGES.bedroom2,
    alt: "Bright bedroom with wood floors and a large window cleaned by Pretty in Pink Cleaning Service near Eclectic, AL",
  },
  {
    src: IMAGES.floors1,
    alt: "Glossy wood floors in an empty room mopped by Pretty in Pink Cleaning Service in Wetumpka, AL",
  },
  {
    src: IMAGES.floors2,
    alt: "Fireplace room with freshly mopped plank floors cleaned by Pretty in Pink Cleaning Service near Eclectic, AL",
  },
  {
    src: IMAGES.moveOut1,
    alt: "Empty move-out-ready room cleaned by Pretty in Pink Cleaning Service in Wetumpka, AL",
  },
  {
    src: IMAGES.hallway1,
    alt: "Tiled hallway swept and mopped by Pretty in Pink Cleaning Service near Montgomery, AL",
  },
  {
    src: IMAGES.stairs1,
    alt: "Vacuumed carpeted staircase cleaned by Pretty in Pink Cleaning Service in Wetumpka, AL",
  },
  {
    src: IMAGES.builtIns1,
    alt: "Dusted built-in shelves detailed by Pretty in Pink Cleaning Service near Prattville, AL",
  },
];
